import { Alert, AlertDescription } from "@/components/ui/alert";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ContentGroup } from "@/lib/types";
import { ContentGroupsSelect } from "@/pages/linkedLicences/ContentGroupsSelect";
import { getScreenSize } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import { useSelector } from "react-redux";

export const PlayerContentGroupSelect: React.FC<{
  defaultScreenSizeGuid?: string;
  customFilter?: (contentGroup: ContentGroup) => boolean;
  onChange: (intId: number) => void;
  onOpenChange: (open: boolean) => void;
  value?: number;
}> = ({ onChange, onOpenChange, value, defaultScreenSizeGuid, customFilter }) => {
  const activeFirm = useSelector(selectActiveFirm);

  const { data: screenSizeData } = useQuery({
    queryFn: () =>
      getScreenSize(
        {
          numberOfObjectsPerPage: 1000,
          pageNumber: 1,
        },
        {
          Firm_Id: String(activeFirm?.firmGuid),
        }
      ),
    queryKey: ["getScreenSize"],
  });

  const screenSizeObj = (screenSizeData?.data?.result || []).find(
    (screenSize) => screenSize.id === defaultScreenSizeGuid
  );

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent className="">
        <DialogHeader>
          <DialogTitle className="mb-2">{t("contentGroup.selectContentGroup")}</DialogTitle>
          {screenSizeObj ? (
            <Alert variant="info">
              <AlertDescription>{t("contentGroup.selectContentGroupDesc", screenSizeObj)}</AlertDescription>
            </Alert>
          ) : null}

          <DialogDescription>
            <ContentGroupsSelect
              onChange={(contentGroup) => {
                onChange(contentGroup.intId);
              }}
              selectedContentGroupIntId={value}
              defaultScreenSizeGuid={defaultScreenSizeGuid}
              customFilter={customFilter}
            />
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
};
